// function getAllBibitems(texText) {
//   var allLines = texText.split("\n");
//   var allBibItems = {};
//   for (var i = 0; i < allLines.length; i++) {
//     var line = allLines[i].trim();
//     if (line.indexOf("\\bibitem") === 0) {
//       try {
//         var nameLine = allLines[i + 1].trim();
//         let laststring = nameLine.substring(nameLine.lastIndexOf(" ") + 1);
//         if (!laststring.includes("}")) {
//           let twolinename = `${allLines[i + 1]} ${allLines[i + 2]}`.trim();
//           let twolinenamereview = allLines[i + 3].trim();
//           let key = new RegExp("{(.*?)}").exec(line)[1];
//           let bibname = new RegExp("{(.*?)}").exec(twolinename)[1];
//           let review = new RegExp("{(.*)}")
//             .exec(twolinenamereview)[1]
//             .replace(/}/g, " ")
//             .replace(/{/g, " ");
//           allBibItems[key.trim()] = { name: bibname, review: review };

// import { all } from "axios";

//           // console.log(allBibItems);
//         }
//         var reviewLine = allLines[i + 2].trim();
//         var key = new RegExp("{(.*?)}").exec(line)[1];
//         var bibname = new RegExp("{(.*?)}").exec(nameLine)[1];
//         var review = new RegExp("{(.*)}")
//           .exec(reviewLine)[1]
//           .replace(/}/g, " ")
//           .replace(/{/g, " ");
//         i = i + 3;
//         allBibItems[key.trim()] = { name: bibname, review: review };
//       } catch (Exc) {
//         // console.log(Exc)
//       }
//     }
//   }
//   return allBibItems;
// }               /\\bibitem\s*\{(.*?)\}\s*\\Name\s*\{([\s\S]+?)\}\s*\\[Rt]\w+\{(.+?)\}\.?$/gm
//previous regex  /\s?\\bibitem\s?\{(.*)?\}\n?\s?\\Name\s?\{(.+\n?.+)\}\n?\s?\\[Rt]\w+\{(.+)\}\.?$/gm
//MARK: bib items
function getAllBibitems(texText) {
  let allbibitems = {};
  let bibRegex = new RegExp(/\\bibitem\{(.+?)\}\s*\\Name\{([\s\S]+?)\}\s*\\[Rr]\w+\{([\s\S]+?)\}\./gm);
  let match;
  while ((match = bibRegex.exec(texText)) !== null) {
    let allbib = match;
    let key = allbib[1];
    let bibname = allbib[2].trim().replace(/\s+/g, ' ');
    let review = allbib[3].trim().replace(/{|}/g, '').replace(/\s+/g, ' ');
    // console.log( bibname,"review:",review);

    allbibitems[key.trim()] = { name: bibname, review: review };
  }
  if (allbibitems != null) {
    return allbibitems;
  }
}

function getAllEquations(texText) {
  let allEqns = {};
  let eqnregex = new RegExp(/\\begin\s*(\{(equation|align|eqnarray|array|case|gather|matrix|multline)\s*\})(.*?)(\\end\1)/gms);
  let res;
  while ((res = eqnregex.exec(texText)) !== null) {
    let eqn = res;
    if (eqn[0].includes("label")) {
      let label = eqn[0].match(/\\label{(.*?)}/g);
      if (label && label.length === 1) {
        label = label[0].replace(/\\label\{/, "").replace(/\}/, "");
        allEqns[label] = { eqn: eqn };
      } else if (label && label.length >= 2) {
        // console.log(label);
        label.forEach((e) => {
          e = e.replace(/\\label\{/, "").replace(/\}/, "");
          allEqns[e] = { eqn: eqn };
        });
      }
    }
  }
  return allEqns;
}

function getAllTables(texText) {
  let allTables = {};
  let tableregex = new RegExp(/\\begin\{table\*?\}(.*?)\\end\{table\*?\}/gims);
  let res;
  while ((res = tableregex.exec(texText)) !== null) {
    let tab = res;
    if (tab[0].includes("label")) {
      let label = tab[0].match(/\\label{(.*?)}/);
      allTables[label[1]] = { tab: tab };
    }
  }
  // console.log(allTables);  
  return allTables;
}

function findRangeInMarkers(selectionRange, markers, cursor) {
  var selectionMarker = {
    startRow: selectionRange.start.row,
    startCol: selectionRange.start.column,
    endRow: selectionRange.end.row,
    endCol: selectionRange.end.column,
  };
  // console.log(markers);
  for (var marker of markers) {
    if (window.event.ctrlKey) {
      if (marker.startRow < marker.endRow) {
        if (
          cursor.row >= marker.startRow &&
          cursor.row <= marker.endRow &&
          marker.startCol <= cursor.column &&
          marker.endCol >= cursor.column
        ) {
          return marker;
        }
      } else if (
        marker.startRow === cursor.row &&
        marker.startCol <= cursor.column &&
        marker.endCol >= cursor.column
      ) {
        return marker;
      }
    } else if (
      marker.startRow === selectionMarker.startRow &&
      marker.startCol === selectionMarker.startCol &&
      marker.endRow === selectionMarker.endRow &&
      marker.endCol === selectionMarker.endCol
    ) {
      return marker;
    }
  }
  return false;
}

function regexFinderTool(lines, allTools) {
  // ace.current.editor.session.getDocument().$lines
  // var lines = allLines.split("\r\n");
  // console.log(lines)
  var all_res = [];
  for (let i = 0; i < lines.length; i++) {
    let text = lines[i];
    for (let tool of allTools) {
      let regexes = tool.regex;
      var matches = text.match(regexes[0]);
      if (regexes.length > 1 && matches != null) {
        const counts = {};
        for (const num of matches) {
          counts[num] = counts[num] ? counts[num] + 1 : 2;
        }
        const total = {};
        for (let match of matches) {
          total[match] = total[match] ? total[match] : counts[match];
          counts[match] = counts[match] - 1;
          let res = { description: tool["text"] };
          let sub_match = match.match(regexes[1]);
          if (sub_match != null) {
            res["line"] = i;
            res["message"] = sub_match;
            res["text"] = sub_match;
            res["nth"] = total[match] - counts[match];
            res["col"] = text
              .split(sub_match, res["nth"])
              .join(sub_match).length;
            all_res.push(res);
          }
        }
        matches = null;
      }
      if (matches != null) {
        // var nth = 0;
        const counts = {};
        for (const num of matches) {
          counts[num] = counts[num] ? counts[num] + 1 : 2;
        }
        const total = {};
        for (let match of matches) {
          total[match] = total[match] ? total[match] : counts[match];
          counts[match] = counts[match] - 1;
          let res = { description: tool["text"] };
          res["line"] = i;
          res["message"] = match;
          res["text"] = match;
          res["nth"] = total[match] - counts[match];
          res["col"] = text.split(match, res["nth"]).join(match).length;
          all_res.push(res);
        }
      }
    }
  }
  return all_res;
}

function downloadFile(content, fileName, type) {
  let blob = new Blob([content], { type });
  let url = window.URL.createObjectURL(blob);
  downloadURI(url, fileName);
  window.URL.revokeObjectURL(url);
  return;
}



function downloadURI(uri, name) {
  let link = document.createElement("a");
  link.download = name;
  link.href = uri;
  link.click();
}

// Show deleted text on Hover

const showDeletedOnHover = (event, changes, setPopUp, popUp, hidePopover) => {
  let cursor = event.getDocumentPosition();

  let marker = changes;

  for (let mark of marker) {
    if (
      mark.startRow === cursor.row &&
      mark.startCol === cursor.column &&
      mark.className.indexOf("Ace_deleted_marker") === 0
    ) {
      setPopUp({
        popup: {
          x: event.x,
          y: event.y,
          show: true,
          header: mark.text,
          type: "deletion",
        },
      });
      return;
    }
    if (popUp.popup.show && popUp.popup.type === "deletion") {
      hidePopover();
    }
  }
};

// Function to identify query in the tex file and answer it 
const querySelector = (ace, props) => {
  if (ace.current) {
    ace.current.editor.$search.$options = {
      // needle: /\\[AQ]\w+({.*?})(\{.*?\})?/g,
      needle: /\\(AQ|Query)({.*?})({.*?})?/g,
      wrap: true,
      caseSensitive: false,
      wholeWord: false,
      regExp: true,
      preventScroll: true,
    };
  }
  var res = ace.current?.editor?.$search.findAll(ace.current?.editor?.session);

  var allqueries = [];
  res?.forEach((element, i) => {
    let question;
    let ans;
    var text = ace.current.editor?.session.getTextRange(element);
    var textSplit = text.split("{");

    question = textSplit[1].replace("}", "");
    if (textSplit[2]) {
      ans = textSplit[2].replace("}", "");
    }
    allqueries.push({
      index: i,
      startrow: element.start.row,
      startcol: element.start.column,
      endrow: element.end.row,
      endCol: element.end.column,
      qns: question,
      ans: ans,
    });
  });
  props.querydata(allqueries);
};

const processSelection = (event, hidePopover, markers, bibitems, setPopUp, ImagePopup, CitationPopup, toast, MathPopup, equations, props, tables, CommentPopup) => {
  hidePopover();
  var cursorPosition = event.editor.selection.getCursor();
  var selectedMarker = findRangeInMarkers(
    event.editor.getSelectionRange(),
    markers,
    cursorPosition
  );
  if (selectedMarker && selectedMarker.className.indexOf("Ace_citation") === 0) {
    // console.log(selectedMarker);
    var bibText = selectedMarker.text;
    var name;
    var review;
    if (bibitems[bibText] === undefined) {
      name = "Citation data not found";
      review = "";
    } else {
      name = bibitems[bibText].name;
      review = bibitems[bibText].review;
    }

    setPopUp({
      popup: {
        x: event.x,
        y: event.y,
        show: true,
        header: bibText,
        body: <CitationPopup name={name} review={review} />,
        type: "citation",
      },
    });
  } else if (
    selectedMarker &&
    selectedMarker.className.indexOf("Ace_reference") === 0
  ) {
    let refText = selectedMarker.text;
    setPopUp({
      popup: {
        x: event.x,
        y: event.y,
        show: true,
        header: refText,
        body: <ImagePopup name={refText} toast={toast} />,
        type: "Image",
      },
    });
  } else if (
    selectedMarker &&
    selectedMarker.className.indexOf("Ace_inline_equation") === 0
  ) {
    let eqn = selectedMarker.text;
    setPopUp({
      popup: {
        x: event.x,
        y: event.y,
        show: true,
        header: "Math Eqn",
        body: <MathPopup equation={eqn} />,
        type: "matheqn",
      },
    });
  } else if (
    selectedMarker &&
    selectedMarker.className.indexOf("Ace_equation") === 0
  ) {
    let eqn = selectedMarker.text;
    let toBeRemoved = ["\\nonumber"]
    for (let r of toBeRemoved) {
      eqn = eqn.replaceAll(r, "")
    }
    setPopUp({
      popup: {
        x: event.x,
        y: event.y,
        show: true,
        header: "Equation",
        body: <MathPopup equation={eqn} />,
        type: "equation",
      },
    });
  } else if (
    selectedMarker &&
    selectedMarker.className.indexOf("Ace_equ_cit") === 0
  ) {
    let eqn_cit = selectedMarker.text;
    let selectedeqn;
    console.log(equations);
    console.log(eqn_cit);

    if (eqn_cit.includes("epl")) {
      selectedeqn = equations[eqn_cit].eqn[0];
    } else {
      selectedeqn = "Run styles first";
    }
    setPopUp({
      popup: {
        x: event.x,
        y: event.y,
        show: true,
        header: "Equation",
        body: <MathPopup equation={selectedeqn} />,
        type: "equation",
      },
    });
  } else if (
    selectedMarker &&
    selectedMarker.className.indexOf("Ace_table_cit") === 0
  ) {
    let refText = selectedMarker.text;
    refText = refText.replace(/Table/, "");
    let selectedtable = tables[refText].tab[0];

    setPopUp({
      popup: {
        x: event.x,
        y: event.y,
        show: true,
        header: refText,
        body: <MathPopup equation={selectedtable} />,
        type: "Image",
      },
    });
  } else {
    if (event.editor.getSelectedText().length > 3) {
      if (CommentPopup) {
        setPopUp({
          popup: {
            x: event.x,
            y: event.y,
            show: true,
            header: "", // No header for comment button initially? Or "Add Comment"?
            body: (
              <CommentPopup
                onSave={(comment) => {
                  console.log("Comment saved:", comment);
                  toast({
                    title: "Comment Added",
                    description: "Your comment has been saved.",
                    status: "success",
                    duration: 2000,
                    isClosable: true,
                  });
                }}
                onClose={hidePopover}
              />
            ),
            type: "comment",
          },
        });
      }
      props.pdfsearch(event.editor.getSelectedText());
    }
  }
};

export {
  getAllBibitems,
  getAllEquations,
  getAllTables,
  findRangeInMarkers,
  regexFinderTool,
  downloadFile,
  downloadURI,
  showDeletedOnHover,
  querySelector,
  processSelection

};
